<div class="obd-page-header">
  <h1><fa-icon class="obd-icon-header" [icon]="faCar"></fa-icon> <span class="font-weight-semibold">OBD List</span></h1>
</div>

<div class="obd-breadcrumb">
  <div class="d-flex">
    <a href="/" class="breadcrumb-item"><fa-icon class="obd-icon" [icon]="faHome"></fa-icon> Home</a>
    <span class="breadcrumb-item active">OBD List</span>		
  </div>
</div>

<div class="obd-page-content">
  <div class="mat-elevation-z8">
    <div class="">
      <div class="input-group mb-3">
        <input class="form-control" matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter Devices">
        <div class="input-group-append">
          <fa-icon class="obd-icon" [icon]="faSearch"></fa-icon>
        </div>
      </div>
   
    </div>
  
    <mat-table #table [dataSource]="dataSource">
  
      <!-- Number Column -->
      <ng-container matColumnDef="no">
        <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.no}} </mat-cell>
      </ng-container>
  
      <!-- Device ID Column -->
      <ng-container matColumnDef="deviceID">
        <mat-header-cell *matHeaderCellDef> Device ID </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.deviceID}} </mat-cell>
      </ng-container>
  
     
      <!-- Details Column -->
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
        <mat-cell *matCellDef="let element"> 
          <a  (click)="viewDeviceDetails(element)"  class="btn default-btn mr-2 float-right" >Details</a>
        </mat-cell>
      </ng-container>
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  
</div>